import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Asset } from "../../../../models/asset"

import ToScheduleDialog from "../dialogs/toScheduleDialog";

interface IToScheduleProps {
    asset: Asset;
    hasMetrics?: boolean;
}
const ToSchedule = ({asset, hasMetrics}: IToScheduleProps) => {
    const navigate = useNavigate();
    const [showScheduleModal, setShowScheduleModal] = useState(false);

    return (
        <>
            <button 
                type="button" 
                // disabled={!!asset.schedulings?.next?.[0]?.date || !hasMetrics}
                onClick={() => navigate(`/control-tower/appointments/appointment?asset=${asset.id}&chassis=${asset.chassis}&name=${asset.name || asset.model}`)}
            >
                <span className={`rioglyph rioglyph-calendar active`} />
            </button>

            <ToScheduleDialog
                asset={asset}
                isOpen={showScheduleModal}
                onClose={() => setShowScheduleModal(false)}
            />
        </>
    )
}

export default ToSchedule;